function SelectField(props: {
  id: string;
  label: string;
  extra?: string;
  placeholder: string;
  variant?: string;
  state?: string;
  disabled?: boolean;
  selectdValue?: string;
  options: Array<{ value: string; label: string }>;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}) {
  const {
    label,
    id,
    extra,
    placeholder,
    variant,
    state,
    disabled,
    options,
    selectdValue,
    onChange,
  } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-navy-700 dark:text-white ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {label}
      </label>
      <select
      
        onChange={onChange}
        disabled={disabled}
        value={selectdValue}
        id={id}
        defaultValue=""
        className={`mt-2 block w-full rounded-xl border bg-white/0 p-3 text-sm outline-none ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error"
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : "border-gray-200 dark:!border-white/10 dark:text-white"
        }`}
      >
        <option disabled value="" className="font-semibold text-gray-700 bg-white">
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value} className="font-semibold text-gray-700 bg-white"  style={{
            fontWeight: 'bold', 
            color: 'gray', 
            backgroundColor: 'white'
          }}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SelectField;
